import styled from 'styled-components';
export var BodyContainer = styled.div.withConfig({
  displayName: "style__BodyContainer",
  componentId: "sc-13qqsya-0"
})(["position:absolute;width:232px;height:390px;margin:auto;margin-left:20%;"]);
export var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "sc-13qqsya-1"
})(["width:100%;margin-top:10px;"]);
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "sc-13qqsya-2"
})(["position:relative;width:100%;display:flex;height:100%;"]);
export var CheckboxContainer = styled.div.withConfig({
  displayName: "style__CheckboxContainer",
  componentId: "sc-13qqsya-3"
})(["order:0;width:19%;margin-left:5px;height:100%;display:flex;align-items:center;"]);
export var Checkbox = styled.div.withConfig({
  displayName: "style__Checkbox",
  componentId: "sc-13qqsya-4"
})(["width:10%;margin:auto;"]);
export var SubItemContainer = styled.div.withConfig({
  displayName: "style__SubItemContainer",
  componentId: "sc-13qqsya-5"
})(["position:relative;width:300px;left:15px;box-shadow:0px 16px 4px rgba(0,0,0,0.4);"]);
export var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "sc-13qqsya-6"
})(["height:25px;box-sizing:border-box;display:flex;justify-content:center;margin:auto;width:50%;"]);
export var PaymentButtonContainer = styled.div.withConfig({
  displayName: "style__PaymentButtonContainer",
  componentId: "sc-13qqsya-7"
})(["position:relative;height:80%;width:60%;text-align:center;margin:auto;"]);
export var PaymentButton = styled.button.withConfig({
  displayName: "style__PaymentButton",
  componentId: "sc-13qqsya-8"
})(["font-weight:600;background-color:#6bcde7;border-color:#6bcde7;line-height:35px;width:75%;margin:auto;color:white;box-shadow:#6bcde7;&:focus{outline:0;border-color:#6bcde7;}border-radius:4px;", ":hover &{background:#6bcde7;}"], PaymentButtonContainer);
export var SubItem = styled.li.withConfig({
  displayName: "style__SubItem",
  componentId: "sc-13qqsya-9"
})(["position:relative;background:#fff;display:flex;width:100%;z-index:99;"]);
export var SubSubItem = styled.li.withConfig({
  displayName: "style__SubSubItem",
  componentId: "sc-13qqsya-10"
})(["position:relative;background:#fff;display:flex;padding-left:10px;width:100%;height:100%;z-index:999;"]);
export var SubItemLabel = styled.div.withConfig({
  displayName: "style__SubItemLabel",
  componentId: "sc-13qqsya-11"
})(["width:300px;display:flex;align-content:flex-start;vertical-align:middle;font-style:normal;font-weight:bold;line-height:normal;font-size:12px;color:#232323;text-align:center;padding:", ";"], function (props) {
  return props.sub ? '0px' : '10px';
});
export var Label = styled.div.withConfig({
  displayName: "style__Label",
  componentId: "sc-13qqsya-12"
})(["width:70%;display:flex;align-content:flex-start;vertical-align:middle;font-style:normal;font-weight:bold;line-height:normal;font-size:14px;color:#000000;text-align:left;margin:auto;margin-top:", ";"], function (props) {
  return props.sub ? '0px' : '3px';
});
export var Box = styled.div.withConfig({
  displayName: "style__Box",
  componentId: "sc-13qqsya-13"
})(["width:70%;border-color:#99c432;border-width:1px;height:30px;line-height:30px;border-style:dotted;font-style:normal;font-weight:400;font-size:14px;color:#232323;text-align:center;margin:auto;margin-top:", ";"], function (props) {
  return props.sub ? '0px' : '3px';
});
export var SubSubItemLabel = styled.div.withConfig({
  displayName: "style__SubSubItemLabel",
  componentId: "sc-13qqsya-14"
})(["width:90%;display:flex;text-transform:uppercase;align-content:flex-start;vertical-align:middle;font-style:normal;font-weight:bold;line-height:normal;font-size:11px;color:gray;text-align:left;padding:", ";"], function (props) {
  return props.sub ? '0px' : '10px';
});
export var Mark = styled.input.withConfig({
  displayName: "style__Mark",
  componentId: "sc-13qqsya-15"
})(["width:2%;height:20px;margin:auto;background-color:", ";"], function (props) {
  return props.color ? props.color : '#fff';
});
export var Circle = styled.div.withConfig({
  displayName: "style__Circle",
  componentId: "sc-13qqsya-16"
})(["width:18px;height:18px;border-radius:50%;margin:auto;margin-left:0px;margin-right:0px;background-color:", ";"], function (props) {
  return props.color ? props.color : '#fff';
});
export var ItemLabel = styled.div.withConfig({
  displayName: "style__ItemLabel",
  componentId: "sc-13qqsya-17"
})(["padding:0px;"]);
export var Title = styled.div.withConfig({
  displayName: "style__Title",
  componentId: "sc-13qqsya-18"
})(["width:100%;height:36px;font-style:normal;font-weight:bold;line-height:normal;font-size:36px;color:rgba(0,0,0,0.51);"]);
export var SubTitle = styled.div.withConfig({
  displayName: "style__SubTitle",
  componentId: "sc-13qqsya-19"
})(["width:100%;height:36px;font-style:normal;font-weight:", ";line-height:", ";font-size:", ";color:", ";margin-top:", ";"], function (props) {
  return props.small ? '600' : '300';
}, function (props) {
  return props.small ? '14px' : 'normal';
}, function (props) {
  return props.small ? '14px' : '18px';
}, function (props) {
  return props.color ? props.color : '#000';
}, function (props) {
  return props.small ? '0' : '15px';
});